import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full border-y border-ink-800 bg-ink-900 py-16" aria-labelledby="garantia" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-92" data-mp="4uqcgsut9wrq">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-start gap-6 px-4 sm:flex-row sm:items-center sm:px-6" data-id="element-93" data-mp="9wfr0ih8sskk">
        <span className="flex h-16 w-16 flex-none items-center justify-center rounded-2xl border border-gold bg-ink-950 text-gold" data-id="element-94" data-mp="jssid9pbeuc5">
          <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-95" data-mp="nt2oqnh0rmrj" />
        </span>
        <div data-id="element-96" data-mp="skcdlluqum2d">
          <h2 id="garantia" className="font-display text-2xl font-900 uppercase tracking-wide text-white" style={{
          fontSize: "20px"
        }} data-id="element-97" data-mp="slvrj5sxgl0z">
            GARANTÍA 7 DÍAS — 
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-slate-300" style={{
          fontSize: "14px"
        }} data-id="element-98" data-mp="12k34zeo0cky8">
            Abres los tomos. Los aplicas en tu proyecto. Si en 7 días no es exactamente lo que esperabas: devolución del 100% sin formularios, sin trámites, sin esperas. 
          </p>
          <p className="mt-2 text-sm text-slate-500" data-id="element-99" data-mp="20s2ikktuy6eg">Tasa de devoluciones: 0.8% (menos de 10 familias de 1.200+) ¿Por qué tan baja? Porque funciona.</p>
        </div>
      </div>
    </section>;
}